import React from 'react'
import './header.css'
import { headerImg } from '../data.js'
import LazyImage from '../../LazyImage.jsx'


function Header () {
  const {header_img_url} = headerImg
  return (
    <div>
        <div className="containerfluid">
            {/* <div className="container-1">
                <header className="container-sub">AADARSH MALTI SKILLS COMPUTER TRAINING INSTITUTION</header>
            </div> */}
            <div className="container-1">
                <header className="">
                  <div className="container-fluid container-3 container-max" id='container-inner-3'>
                    <a className='header-links' href='https://web.whatsapp.com/send?phone=9494760846&text=Hi%2C%20we%20are%20interested%20to%20join%20in%20your%20institute.%20Need%20some%20info.' target='blank'><i id='font' className="fas fa-phone-volume"></i><span id='txt'>&nbsp;+91 9494760846</span>&nbsp;<span id='txt'>|</span>&nbsp;<span id='txt'>8019812384</span>&nbsp;</a>
                    <span><a className='header-links' href='https://mail.google.com/mail/?view=cm&to=aadarshmaltiskills2@gmail.com&su=Admission%20Enquiry&body=Hi%2C%20we%20are%20interested%20to%20join%20in%20your%20institute.%20Please%20share%20details.' target='blank'><i id='font' className="fas fa-envelope-open-text"></i><span id='txt'>&nbsp;aadarshmaltiskills2@gmail.com</span></a></span>&nbsp;
                    <span><a className='header-links' href='https://www.google.com/maps/place/Aadarsh+Malti+Skills/@16.6434756,80.5509733,11.98z/data=!4m6!3m5!1s0x3a35ebe322aa5ccb:0xabe38ca7549d3b3b!8m2!3d16.6148797!4d80.5401213!16s%2Fg%2F11cr_np8jm?hl=en&entry=ttu&g_ep=EgoyMDI1MDcxNi4wIKXMDSoASAFQAw%3D%3D' target='blank'><i id='font' className="fas fa-map-marker-alt"></i><span id='txt'>&nbsp;Kondapalli, Vijayawada</span></a></span>
                   </div>                  
                </header>
            </div>

            	{/* <div className="container-2">
                    <img src='img/logo.webp' alt="logo" id='logo' style={{width: '100px', height: '100px'}}/>
                    <div id="heading">
                    <p id="h1">AADARSH MALTI SKILLS</p>
                    <p id="h_1"></p>
                    <p id="h1-1"><i>Adarsh Compter Training Institute</i></p>
                    </div>

         
		        </div> */}
            <div className="container-2">
              {/* <img src={header_img_url} alt="logo" style={{width: '100%', height: '215px'}}/> */}
              <a href='/'><LazyImage src={header_img_url} alt="logo" className="#" style={{width: '100%', height: '215px'}}/></a>

            </div>
        </div>
    </div>
  )
}

export default Header